// extracted by mini-css-extract-plugin
export var section = "contact-module--section--9lVmr";
export var columns = "contact-module--columns--BiS1r";
export var column = "contact-module--column--wbKGF";
export var marginBottom = "contact-module--marginBottom--xhm5y";
export var text = "contact-module--text--R68do";
export var map = "contact-module--map--85Yei";
export var btns = "contact-module--btns--c8UD+";
export var phone = "contact-module--phone--rEtHz";